<template>
  <section>
    <header>
      <h5>
        Filtrar
      </h5>
    </header>
    <div class="frame fixed">
      <div class="row no-padd" ref="produtoFilterForm">
        <div class="col-md-6 form-group">
          <label>Unidade</label>
          <select-control v-model="filter.unidade" name="unidade" :options="options.unidades" placeholder="Selecione" @change="onUnidadeChange()" :disabled="loading"/>
        </div>
        <div class="col-md-4 form-group">
          <label>Tipo de Curso</label>
          <select-control v-model="filter.tipoCurso" name="tipoCurso" :options="options.tipoCurso" placeholder="Selecione" :disabled="loading" @change="onTipoCursoChange()"/>
        </div>
        <div class="col-md-4 form-group">
          <label>Período Letivo</label>
          <select-control v-model="filter.periodoLetivo" :options="options.periodosLetivos" placeholder="Selecione" @change="onPeriodoLetivoChange()" :disabled="loading"/>
        </div>
        <div class="col-md-4 form-group">
          <label>Curso</label>
          <select-control v-model="filter.cursos" :options="options.cursos" placeholder="Selecione" :disabled="loading" @change="onCursoChange()"/>
        </div>
        <div class="col-md-4 form-group">
          <label>Série</label>
          <select-control v-model="filter.series" :options="options.series" placeholder="Selecione" :disabled="loading"/>
        </div>
      </div>
      <div class="col-md-12 form-actions form-group">
        <button type="button" @click="getTurmas()" class="btn btn-primary" :disabled="loading">
          Buscar
        </button>
        <button type="button" @click="clearFilter()" class="btn btn-secondary" :disabled="loading">
          Limpar
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import UserService from '@/services/user.service.js'
import AcademicoService from '@/services/academico.service.js'
import { createSelectOptions } from '@/services/utils.service.js'

export default {
  data () {
    return {
      filter: {
        unidade: null,
        periodoLetivo: null,
        tipoCurso: null,
        cursos: null,
        series: null
      },
      wait: {
        unidades: false,
        tipoCurso: false,
        cursos: false
      },
      options: {
        unidades: [],
        tipoCurso: [],
        periodosLetivos: [],
        series: [],
        turmas: [],
        cursos: [],
      },
      cursos: [],
      series: [],
      loading: false
    }
  },
  mounted () {
    this.loading = true
    window.spinner.emit("open")
    Promise.all([
      this.getUnidades(),
      this.getTipoCurso(),
      this.getCursos()
    ]).finally(() => {
      this.loading = false
      window.spinner.emit("close")
    })
  },
  methods: {
    getUnidades () {
      return UserService.getMinhasUnidades().then(
        response => {
          console.log("getMinhasUnidades:", response.data)
          this.options.series = []
          this.options.periodosLetivos = []
          
          if ( response.data.length > 0 ) {
            this.options.unidades = createSelectOptions(response.data, 'idUnidade' ,'descricao')
            this.wait.unidades = true
          } else {
            window.toaster.emit('open', {style: "error", message: "Nenhuma unidade encontrada. Verifique sua conexão e tente novamente.", floater: true})
          }
          
          this.finishLoad()
        },
        error => {
          console.error(error)
          window.toaster.emit('open', {style: "error", message: "Ops. Algo aconteceu. Nenhuma unidade encontrada. Verifique sua conexão e tente novamente.", floater: true})
        }
      )
    },
    getTipoCurso () {
      return AcademicoService.getTipoCurso().then(
        response => {
          console.log("getTipoCurso:", response.data)
          if ( response.data.length > 0 ) {
            this.options.tipoCurso = createSelectOptions(response.data, 'idTipoCurso' ,'descricao')
            this.wait.tipoCurso = true
          } else {
            window.toaster.emit('open', {style: "error", message: "Nenhum tipo de curso encontrado. Verifique sua conexão e tente novamente.", floater: true})
          }
          
          this.finishLoad()
        },
        error => {
          console.error(error)
          window.toaster.emit('open', {style: "error", message: "Ops. Algo aconteceu. Nenhum tipo de curso encontrado. Isto parece ser um problema de parametrização.", floater: true})
        }
      )
    },
    getCursos () {
      return AcademicoService.getCursos().then(
        response => {
          console.log("getCursos:", response.data)
          if ( response.data.length > 0 ) {
            this.cursos = response.data
            this.options.cursos = createSelectOptions(response.data, 'idCurso' ,'descricao')
            this.wait.cursos = true
          } else {
            window.toaster.emit('open', {style: "error", message: "Nenhum curso encontrado. Isto parece ser um problema de parametrização.", floater: true})
          }

         
          this.finishLoad()
        },
        error => {
          console.error(error)
          window.toaster.emit('open', {style: "error", message: "Ops. Algo aconteceu. Nenhum curso encontrado. Isto parece ser um problema de parametrização.", floater: true})
        }
      )
    },
    getPeriodosLetivos () {
      this.loading = true
      return AcademicoService.getPeriodosLetivos(this.filter.unidade).then(
        response => {
          console.log("getPeriodosLetivos:", response.data)
          
          if ( response.data.length > 0 ) {
            this.options.periodosLetivos = createSelectOptions(response.data, 'idPeriodoLetivo' ,'descricao').reverse()
          } else {
            window.toaster.emit('open', {style: "error", message: "Nenhum período letivo encontrado para esta unidade. Isto parece ser um problema de parametrização.", floater: true})
          }
          this.loading = false
        },
        error => {
          console.error(error)
          this.loading = false
          window.toaster.emit('open', {style: "error", message: "Ops. Algo aconteceu. Nenhum período letivo encontrado para esta unidade. Isto parece ser um problema de parametrização.", floater: true})
        }
      )
    },
    onUnidadeChange () {
      this.filter.periodoLetivo = null
      this.filter.series = null
      this.options.periodosLetivos = []
      this.options.series = []
      this.$emit('clear')
      if ( this.filter.unidade ) {
        this.getPeriodosLetivos()
      }
    },
    onTipoCursoChange () {
      this.filter.cursos = null
      this.filter.series = null
      this.options.series = []
      this.selectTipoCurso()
      if ( this.filter.periodoLetivo ) {
        this.getSeries()
      }
    },
    onPeriodoLetivoChange () {
      this.filter.series = null
      this.options.series = []
      if ( this.filter.periodoLetivo ) {
        this.getSeries()
      }
    },
    onCursoChange () {
      this.filter.series = null
      this.selectCurso()
    },
    getSeries () {
      this.loading = true
      // const tipoCurso = 
      return AcademicoService.getSeries(this.filter.periodoLetivo, this.filter.tipoCurso).then(
        response => {
          console.log("getSeries:", response.data)
          this.options.series = []

          if ( response.data.length > 0 ) {
            this.series = response.data
            response.data.map( k => {
              k.label = k.descricao + ' ' + k.descricaoTurno
            })
            this.options.series = createSelectOptions(response.data, 'idSerie' ,'label')
            if ( this.filter.cursos ) {
              this.selectCurso()
            }
            
          } else {
            window.toaster.emit('open', {style: "error", message: "Nenhuma série encontrada para este período letivo. Isto parece ser um problema de parametrização.", floater: true})
          }

          this.loading = false
        },
        error => {
          console.error(error)
          this.loading = false
          window.toaster.emit('open', {style: "error", message: "Ops. Algo aconteceu. Nenhuma série encontrada para este período letivo. Isto parece ser um problema de parametrização.", floater: true})
        }
      )
    },
    getTurmas () {
      this.loading = true

      const options = {
        idUnidade: this.filter.unidade,
        idTipoCurso: this.filter.tipoCurso,
        idPeriodoLetivo: this.filter.periodoLetivo,
        idCurso: this.filter.cursos,
        idSerie: this.filter.series
      }
      
      window.spinner.emit("open")

      AcademicoService.getTurmasProximoCiclo( options ).then(
        response => {
          console.log("getTurmas:", response.data)
          if ( response.data.length > 0 ) {
            this.$emit('onFilter', response.data)
          } else {
            this.$emit('onFilter', [])
            window.toaster.emit('open', {style: "warning", message: "Nenhuma turma encontrada para os filtros informados.", floater: true})
          }
          this.loading = false
          window.spinner.emit("close")
        },
        error => {
          console.error(error)
          this.$emit('onFilter', [])
          this.loading = false
          window.spinner.emit("close")
          window.toaster.emit('open', {style: "error", message: "Ops. Algo aconteceu. Nenhuma turma encontrada para esta série. Isto parece ser um problema de parametrização.", floater: true})
        }
      )
    },
    selectCurso () {
      const selected = this.filter.cursos
      this.loading = true

      if ( !selected ) {
        this.options.series = createSelectOptions(this.series, 'idSerie', 'label')
        this.loading = false
        return
      }
      
      const result = this.series.filter( k => {
        return k.idCurso == selected
      })

      if ( result.length > 0 ) {
        this.options.series = createSelectOptions(result, 'idSerie' ,'label')
      } else {
        this.options.series = []
      }
      this.loading = false
    },
    selectTipoCurso () {
      const selected = this.filter.tipoCurso
      this.loading = true

      if ( !selected ) {
        this.options.cursos = createSelectOptions(this.cursos, 'idCurso', 'descricao')
        this.loading = false
        return
      }
      
      const result = this.cursos.filter( k => {
        return k.idTipoCurso == selected
      })
      
      if ( result.length > 0 ) {
        this.options.cursos = createSelectOptions(result, 'idCurso' ,'descricao')
      } else {
        this.options.cursos = []
      }
      this.loading = false
    },
    finishLoad () {
      const finished = !Object.values(this.wait).some( a => !a)

      if ( finished ) {
        window.spinner.emit("close")
        this.loading = false
      }
      // console.log("finished:", finished)

    },
    clearFilter ( part ) {

      if ( !part ) {
        this.filter = {
          unidade: null,
          periodoLetivo: null,
          tipoCurso: null,
          cursos: null,
          series: null
        }

        this.options.periodosLetivos = []
        this.options.series = []
        this.options.cursos = createSelectOptions(this.cursos, 'idCurso', 'descricao')

        this.$emit('clear')
      } else if ( part === 'tipoCurso' ) {
        this.filter.cursos = null
        this.filter.series = null
        this.options.series = []
      } else if ( part === 'periodoLetivo' ) {
        this.filter.series = null
        this.options.series = []
      } else if ( part === 'curso' ) {
        this.filter.series = null
        this.options.series = this.series.length > 0
          ? createSelectOptions(this.series, 'idSerie', 'label')
          : []
      }
      
    }
  }
}
</script>

<style scoped lang="scss">
  header {
    margin: $hmg $hmg_small;
    padding: 0 $hmg_mini;

    h5 {
      margin: 0 0 $hmg_mini 0; padding: 0;
    }
    p {
      margin: 0; padding: 0;
    }
  }

  // .frame {
  //   padding: 0 $hmg_small
  // }
  .form-actions {
    margin-top: $hmg !important
  }
</style>
